<template>
  <ErrorPage />
</template>
<script setup lang="ts">
  import ErrorPage from "~/layouts/error.vue";
</script>
